var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('s-aside',[_c('div',{staticClass:"mt-5",attrs:{"s":"","id":"left-section"}},[_c('send-credits')],1)]),_c('s-content',{staticClass:"s-sticky-aside s-content s-aside-1 float-left mt-5"},[_c('div',{attrs:{"id":"item-tpl-ct"}},[_c('credits-history')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }